import { resource } from "@app/common/localization/resource";
import React from "react";
import { InvestButton } from "./InvestButton";

export const StartInvesting: React.VFC = () => (
  <section style={{ padding: "4em 0 4em", textAlign: "center" }}>
    <div className="container">
      <div style={{ justifyContent: "center" }} className="row">
        <InvestButton>{resource("landing.btnStart3")}</InvestButton>
      </div>
    </div>
  </section>
);
